export default __webpack_public_path__ + "static/Panasonic Indoor-a4b60d3ed924493981553ff50593dd3b.jpg";